<template>
  <div class="l-workflow" v-if="entryData">
    <div class="menu">
      <SiteMenu :navigation="entryData.workflows"></SiteMenu>
    </div>
    <div class="l-workflow__main">
      <div class="header">
        <div class="header__title">
          <h1>{{ entryData.title }}</h1>
          <div class="header__title__nav">
            <a
              class="back"
              href="/"
              @click.prevent="navigate('homepage', 'fade')"
            >
              <iArrow />
            </a>
            <p>BACK</p>
          </div>
        </div>
        <a
          class="header__logo"
          href="/"
          @click.prevent="navigate('homepage', 'fade')"
        >
          <iPort />
        </a>
      </div>
      <component :is="entryData.workflow"></component>
    </div>
    <pNavigation :navigation="entryData.workflows"></pNavigation>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { RestComponent } from "@/js/mixins/rest-component.js";
import { mapState } from "vuex";
import axios from "axios";

import SiteMenu from "@/js/components/SiteMenu.vue";

// Partials
import pNavigation from "@/js/templates/partials/p-navigation.vue";

// Workflows
import cargoOperations from "@/js/templates/workflow/CargoOperations.vue";
import fisheries from "@/js/templates/workflow/Fisheries.vue";
import offShoreWind from "@/js/templates/workflow/OffshoreWind.vue";
import oilAndGas from "@/js/templates/workflow/OilAndGas.vue";
import portServices from "@/js/templates/workflow/PortServices.vue";
import vesselServices from "@/js/templates/workflow/VesselServices.vue";
import recycling from "@/js/templates/workflow/recycling.vue";

import iPort from "@/assets/logo/portesbjerg.svg";
import iArrow from "@/assets/icon/arrow.svg";

export default defineComponent({
  name: "Workflow",
  mixins: [RestComponent],
  components: {
    SiteMenu,

    pNavigation,

    cargoOperations,
    fisheries,
    offShoreWind,
    oilAndGas,
    portServices,
    vesselServices,
    recycling,

    iPort,
    iArrow,
  },
  methods: {
    updateEntryData(res) {
      this.$store.commit("app/setEntryData", res.data);
    },
  },
  computed: {
    ...mapState({
      url: (state) => state.app.siteUrl,
      routes: (state) => state.app.routes,
    }),
  },
  mounted() {
    window.addEventListener("resize", this.setViewHeight);
  },
  destroyed() {
    window.addEventListener("resize", this.setViewHeight);
  },
  beforeRouteEnter(to, from, next) {
    axios.get(to.meta.endpoint).then((response) =>
      next((vm) => {
        vm.$data.entryData = response.data;
        vm.updateEntryData(response);
      })
    );
  },
});
</script>

<style lang="scss">
@import "@/scss/app.scss";

.l-workflow {
  display: flex;
  overflow-y: hidden;
  overflow-x: hidden;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);

  .menu {
    display: none;
  }

  &::-webkit-scrollbar {
    width: 0 !important;
    display: none !important;
  }
  -ms-overflow-style: none !important;
  scrollbar-width: none !important;

  &__main {
    display: flex;
    flex: 1;
    background-color: $brand-blue;
    position: relative;

    .header {
      top: 58px;
      padding-right: 50px;
      padding-left: 50px;
      // margin-right: 80px;
      display: flex;
      width: 100%;
      justify-content: space-between;
      position: absolute;
      z-index: 10;
      pointer-events: none;

      &__title {
        margin-top: -12px;
        h1 {
          color: $brand-white;
          font-size: 35px;
          line-height: 35px;
          font-weight: $f-bold;
          max-width: 274px;
          margin-bottom: 23px;
        }
        &__nav {
          display: flex;
          align-items: center;

          .back {
            width: 36px;
            height: 36px;
            min-width: 36px;
            background-color: transparent;
            border-radius: 50%;
            margin-right: 10px;
            border: 1px solid #ebedef;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: $t-hover;
            pointer-events: all;

            svg {
              path {
                transition: $t-hover;
                fill: $brand-white;
              }
            }

            &:hover {
              background-color: $brand-white;
              transition: $t-hover;
              svg {
                path {
                  transition: $t-hover;
                  fill: $brand-blue;
                }
              }
            }
          }
          p {
            color: $brand-white;
            font-size: 12px;
            font-weight: $f-semibold;
          }
        }
      }

      &__logo {
        // margin-top: 12px;
        height: fit-content;
        pointer-events: all;
        svg {
          width: 130px;
          cursor: pointer;
        }
      }
    }
  }
}

@media all and (max-width: 1024px) {
  .l-workflow {
    &__main {
      &::after {
        pointer-events: none;
        content: "";
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0.3) 0%,
          rgba(0, 0, 0, 0) 200px,
          rgba(0, 0, 0, 0) 100%
        );
        position: absolute;
      }
    }
  }
}

@media all and (max-width: 768px) {
  .l-workflow {
    &__main {
      .header {
        &__title {
          h1 {
            color: $brand-white;
            font-size: 24px;
            line-height: 24px;
            font-weight: $f-bold;
            max-width: 274px;
            margin-bottom: 23px;
          }
        }
      }
    }
  }
}

@media all and (max-width: 500px) {
  .l-workflow {
    .menu {
      display: block;
      position: absolute;
      right: 20px;
      top: 30px;
      z-index: 200;
    }
    &__main {
      .header {
        top: 30px;
        padding-left: 20px;
        &__title {
          margin-top: 0;
          h1 {
            color: $brand-white;
            font-size: 24px;
            line-height: 24px;
            font-weight: $f-bold;
            max-width: 274px;
            margin-bottom: 20px;
          }
        }
        &__logo {
          display: none;
        }
      }
    }
  }
}

@media all and (max-height: 600px) {
  .l-workflow {
    &__main {
      .header {
        top: 30px;
        padding-left: 20px;
        &__title {
          margin-top: 0;
          h1 {
            color: $brand-white;
            font-size: 24px;
            line-height: 24px;
            font-weight: $f-bold;
            max-width: 274px;
            margin-bottom: 20px;
          }
        }
        &__logo {
          display: none;
        }
      }
    }
  }
}
</style>
